import * as DialogPrimitive from '@radix-ui/react-dialog';
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';

import { cx } from '../cva';

export type ModalTitleProps = DialogPrimitive.DialogTitleProps & {
    hidden?: boolean;
};

export function ModalTitle({ className, hidden, ...props }: ModalTitleProps) {
    const element = (
        <DialogPrimitive.DialogTitle
            {...props}
            className={cx('text-xl font-semibold lg:text-2xl', className)}
        />
    );

    if (!hidden) {
        return element;
    }

    return <VisuallyHidden.Root>{element}</VisuallyHidden.Root>;
}
